import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import useModal from 'src/components/Modal/useModal';
import { Task } from 'src/types';

import TaskHandlerModal from '../../../../shared/TaskHandlerModal';


const TaskHandlerButton = ({ task, onSuccess }: { task: Task, onSuccess: () => void }) => {
  const {
    isOpen,
    openModal,
    closeModal,
    modalContent
  } = useModal();
  return (
    <>
      {
        isOpen && (
          <TaskHandlerModal
            task={modalContent}
            onClose={closeModal}
            engagementId={task.engagementId}
            onSuccess={onSuccess}
          />
        )
      }
      <Tooltip title="View task">
        <IconButton
          edge="end"
          onClick={() => openModal(task)}
        >
          <OpenInNewIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default TaskHandlerButton;
